import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { mediaUrl } from "@/lib/media";
import { useLang } from "@/i18n";

export default function CarouselViewer({ slides = [], fallbackImage }) {
  const { t } = useLang();
  const [i, setI] = useState(0);
  if (!slides.length) return null;
  const s = slides[i];
  const mediaSrc = s.media_id ? mediaUrl(s.media_id) : (fallbackImage || null);

  return (
    <div data-testid="carousel-viewer">
      <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border-2 border-stone-200 bt-gradient">
        {mediaSrc && <img src={mediaSrc} alt="" className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-black/20" />
        <div className="absolute inset-0 p-6 flex flex-col justify-end text-white">
          {s.heading && <div className="font-head font-black text-2xl sm:text-3xl leading-tight drop-shadow-lg">{s.heading}</div>}
          {s.text && <p className="mt-2 text-white/95 drop-shadow">{s.text}</p>}
        </div>
        <div className="absolute top-3 right-3 bg-black/40 text-white text-xs font-bold px-3 py-1 rounded-full">
          {t("slide")} {i + 1}/{slides.length}
        </div>
        {i > 0 && (
          <button onClick={() => setI(i - 1)} data-testid="carousel-prev"
            className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 text-stone-800 grid place-items-center shadow">
            <ChevronLeft size={22} />
          </button>
        )}
        {i < slides.length - 1 && (
          <button onClick={() => setI(i + 1)} data-testid="carousel-next"
            className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 text-stone-800 grid place-items-center shadow">
            <ChevronRight size={22} />
          </button>
        )}
      </div>
      <div className="flex justify-center gap-2 mt-3">
        {slides.map((_, idx) => (
          <button key={idx} onClick={() => setI(idx)}
            className={`h-2 rounded-full transition-all ${idx === i ? "w-6 bg-primary" : "w-2 bg-stone-300"}`} />
        ))}
      </div>
    </div>
  );
}
